<script setup lang="ts">
import { ref } from 'vue'
import mailingsHttpService from '@/services/http/mailingsHttpService'
import type {
  EmailTemplateModel,
  EmailTemplateTranslationModel,
} from '@/services/http/httpResponses'
import { Roles } from '@/constants'

definePage({
  meta: { allowedRoles: [Roles.Admin] },
})

const templates = ref<EmailTemplateModel[]>([])
const selectedTemplate = ref<EmailTemplateModel | null>(null)
const selectedTranslation = ref<EmailTemplateTranslationModel | null>(null)
const showPreviewDialog = ref(false)

const load = async () => {
  const res = await mailingsHttpService.getEmailTemplates()
  templates.value = res.templates
}

const openPreview = (template: EmailTemplateModel, translation: EmailTemplateTranslationModel) => {
  selectedTemplate.value = template
  selectedTranslation.value = translation
  showPreviewDialog.value = true
}

await load()
</script>

<template>
  <div class="flex flex-col gap-4 w-full">
    <h2 class="text-2xl font-semibold">Email-шаблоны</h2>

    <DataTable :value="templates" dataKey="id">
      <Column field="code" header="Код" style="min-width: 14rem" />
      <Column header="Предпросмотр" style="min-width: 18rem">
        <template #body="slotProps">
          <div class="flex gap-2 flex-wrap">
            <Button
              v-for="tr in slotProps.data.translations"
              :key="tr.languageCode"
              :label="tr.languageCode.toUpperCase()"
              size="small"
              outlined
              @click="openPreview(slotProps.data, tr)"
            />
          </div>
        </template>
      </Column>
      <template #empty>
        <div class="flex flex-col gap-4 items-center">
          <span class="pi pi-envelope text-6xl" />
          <h3 class="font-medium">Шаблоны не найдены</h3>
        </div>
      </template>
    </DataTable>

    <Dialog
      v-model:visible="showPreviewDialog"
      :header="`${selectedTemplate?.code} · ${selectedTranslation?.languageCode?.toUpperCase()}`"
      :modal="true"
      class="w-[95vw] max-w-4xl"
      :closable="true"
    >
      <div v-if="selectedTranslation" class="flex flex-col gap-4">
        <div>
          <p class="text-sm text-gray-500 mb-1">Тема письма</p>
          <p class="font-medium">{{ selectedTranslation.subject }}</p>
        </div>
        <div>
          <p class="text-sm text-gray-500 mb-1">HTML-тело</p>
          <iframe
            :srcdoc="selectedTranslation.htmlBody"
            class="w-full border rounded"
            style="height: 60vh"
          />
        </div>
      </div>
    </Dialog>
  </div>
</template>

<style scoped></style>
